import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class Sept2022 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Sept2022'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/banner.jpg" alt="Diamonds Direct" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/banner_m.jpg" alt="Diamonds Direct" />
			</div>
			
			<div className='blockSection'>
				<div className='blockSectionWrapper'>
					<div className={'blockItem newlywedBlock'}>
						<div className='mainRow'>
							<div className={'mrBlock imgBlock mobileMakeup'} onClick={() => this.internalNav('jewelry/NFANC30055')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/hero_m.jpg" alt="Diamonds Direct" />
							</div>
							<div className={'mrBlock copyBlock'}>
								<div className='mrBlockWrapper'>
									<div className='mrHeaderCopy'>Start your forever with a purchase of a lifetime online or in-store and take advantage of</div>
									
									<div className='mrHeadline'>0% APR for 5 Years<sup style={{ fontWeight: '300', fontSize: '18px' }}>1</sup></div>
									<div className='mrSubheader'>Subject to credit approval.</div>

									<div className='mrDates'>Now - October 2</div>
									<div className='mrSubheader'>Special Sunday Hours<br />October 2nd 12pm-5pm</div>

									<div className='mrButton' onClick={() => this.openNew('https://retailservices.wellsfargo.com/ahapp/init-app?m=2171050826')}>Ready to Apply</div>

								</div>
							</div>
							<div className={'mrBlock imgBlock rightImg'} onClick={() => this.internalNav('jewelry/NFANC30055')}>
								<img src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/hero.jpg" alt="Diamonds Direct" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className='cheersBlock'>
				<div className='cheersBlockWrapper'>
					<div className={'itemRow cbItems'} style={{marginBottom: '25px'}}>
						<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/collage.jpg" alt="Diamonds Direct" />
						<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/promopages/sept2022/landing/collage_m.jpg" alt="Diamonds Direct" />
						<div className={'cbiLink cbi1'} onClick={() => this.internalNav('jewelry/BLDMD23367')}></div>
						<div className={'cbiLink cbi2'} onClick={() => this.internalNav('jewelry/NFANC30016')}></div>
						<div className={'cbiLink cbi3'} onClick={() => this.internalNav('band/BLDMD33675')}></div>
						<div className={'cbiLink cbi4'} onClick={() => this.internalNav('setting/SMD1459007')}></div>
						<div className={'cbiLink cbi5'} onClick={() => this.internalNav('jewelry/EHOOP05011')}></div>
					</div>
				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome! But if you’d prefer to set up an appointment online or in store, please use the form below and we will follow up to confirm!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Sept2022;

function mapStateToProps(state) {
  return {

  };
}

export const Sept2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Sept2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/sept2022/Sept2022.jsx